module.exports = __webpack_public_path__ + "img/v60.5aef5879.jpg";